<template>
  <div id="app">
    <AppNavbar />
    <AppNavbarMenu />
     <!-- Popup -->
     <!-- <Popup /> -->
      <router-view />
    <Footer />

    <!-- Go to Top Button -->
    <button @click="scrollToTop" class="btn-go-top" v-if="showGoTopButton">
      <i class="fa-solid fa-arrow-up"></i>
    </button>
  </div>
</template>

<script>
import AppNavbar from './components/Navbar.vue';
import AppNavbarMenu from './components/NavbarMenu.vue';
import Footer from './components/Footer.vue';
import Popup from './components/Popup.vue';


export default {
  name: 'App',
  components: {
    AppNavbar,
    AppNavbarMenu,
    Footer,
    Popup
  },
  data() {
    return {
      showGoTopButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      if (window.scrollY > 300) {
        this.showGoTopButton = true;
      } else {
        this.showGoTopButton = false;
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style>
.btn-go-top {
  position: fixed;
  bottom: 20px;
  right: 40px;
  background-color: #efefef;
  color: #000000;
  border: none;
  border-radius: 50%;
  padding: 15px 20px;
  cursor: pointer;
}

.btn-go-top:hover {
  background-color: #d57e3d;
}
</style>
